import classNames from "classnames";
import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme) => ({
	checkboxWrapper: {
		position: "relative",
	},
	checkboxElement: {
		margin: "0 10px 0 0",
	},
	input: {
		opacity: 0,
		position: "absolute",
	},
	checkbox: {
		width: "28px",
		height: "30px",
		display: "inline-block",
		padding: "3px",
		border: "1px solid " + theme.palette.colors.oneMoreGrey,
		borderRadius: "5px",
	},
	icon: {
		fontSize: "20px",
		color: theme.palette.colors.purplishBlue,
	},
	iconUnChecked: {
		opacity: 0,
	},
	label: {
		fontSize: "16px",
		fontFamily: theme.fonts.medium,
		color: theme.palette.colors.darkSlateBlue,
		lineHeight: "1.5",
		letterSpacing: "1px",
	},
}));

const Checkbox = ({ checked, onChange, label }) => {
	const classes = useStyles();

	return (
		<div className={classes.checkboxWrapper}>
			<label className={classes.checkboxElement}>
				<input type="checkbox" checked={checked} onChange={onChange} className={classes.input} />
				<div className={classes.checkbox}>
					<div
						className={classNames("icon24 icon-check", classes.icon, {
							[classes.iconUnChecked]: !checked,
						})}
					/>
				</div>
			</label>
			{label && <span className={classes.label}>{label}</span>}
		</div>
	);
};

export default Checkbox;
